import {Observable} from 'rxjs';
import * as Rx from 'rxjs/Rx';

export class ArrayUtils {

    public static _groupByWithTwoKey(data : Array<any>,key1:string,key2:string) :  Observable<Array<any>>{
        return  Rx.Observable.from(data)
            .groupBy( x => x[key1][key2])
            .flatMap(group => group.toArray())
            .toArray();
    }

    public static _groupByWithOneKey(data : Array<any>,key1:string) :  Observable<Array<any>>{
        return  Rx.Observable.from(data)
            .groupBy( x => x[key1])
            .flatMap(group => group.toArray())
            .toArray();
    }
    public static _groupByWithThreeKey(data : Array<any>,key1:string,key2:string,key3:string) :  Observable<Array<any>>{
        return  Rx.Observable.from(data)
            .groupBy( x => x[key1][key2][key3])
            .flatMap(group => group.toArray())
            .toArray();
    }
}
